import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import Parse from 'parse'
import { Route } from 'react-router-dom'
import Config from '../config'

export default class ExperimentListComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      experiments: null,
      statusFilter: null
    }
    this.loadContent()
  }

  loadContent = async () => {
    try {
      const sessionToken = Parse.User.current()?.getSessionToken()
      if (!sessionToken) return

      const baseUrl = Config.serverUrl.replace('/parse/', '')
      const response = await fetch(`${baseUrl}/api/experiments`, {
        headers: { 'x-parse-session-token': sessionToken }
      })

      if (!response.ok) {
        const data = await response.json()
        throw new Error(data.error || 'Failed to load experiments')
      }

      let results = await response.json()
      if (this.state.statusFilter) {
        results = results.filter(e => e.status === this.state.statusFilter)
      }
      results.sort((a, b) =>
        new Date(b.createdAt) - new Date(a.createdAt)
      )
      this.setState({ experiments: results })
    } catch (error) {
      console.error('Error loading experiments:', error)
      window.alert('Error loading experiments: ' + error.message)
    }
  }

  handleNew = () => {
    window.location.href = '/#/experiments/new'
    window.location.reload()
  }

  handleStatusFilter = (status) => {
    this.setState({ statusFilter: status }, () => {
      this.loadContent()
    })
  }

  renderStatus = (status) => {
    switch (status) {
      case 'draft':
        return (<span className="badge text-bg-secondary">Draft</span>)
      case 'running':
        return (<span className="badge text-bg-success">Running</span>)
      case 'paused':
        return (<span className="badge text-bg-warning">Paused</span>)
      case 'ended':
        return (<span className="badge text-bg-dark">Ended</span>)
      default:
        return (<span className="badge text-bg-light">{status}</span>)
    }
  }

  renderVariants = (variants) => {
    if (!variants || !variants.length) return 'None'
    return variants.map(v => `${v.key} (${v.weight}%)`).join(', ')
  }

  renderTable = () => {
    if (!this.state.experiments) {
      return (<div className="text-muted">Loading...</div>)
    }
    if (!this.state.experiments.length) {
      return (<div className="text-muted">No experiments found</div>)
    }

    return (
      <table className="table table-hover">
        <thead className="table-light">
          <tr>
            <th>Key</th>
            <th>Name</th>
            <th>Platform</th>
            <th>Status</th>
            <th>Variants</th>
            <th>Created</th>
          </tr>
        </thead>
        <tbody>
          {this.state.experiments.map((exp) => (
            <tr
              key={exp.id}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                window.location.href = '/#/experiments/' + exp.id
                window.location.reload()
              }}
            >
              <td><code>{exp.key}</code></td>
              <td>{exp.name}</td>
              <td>{exp.platform || 'all'}</td>
              <td>{this.renderStatus(exp.status)}</td>
              <td>{this.renderVariants(exp.variants)}</td>
              <td>{new Date(exp.createdAt).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  render = () => {
    const { statusFilter } = this.state
    return (
      <div>
        <Route path="/experiments">
          <div className="container">
            <br />
            <div className="row justify-content-between">
              <div className="col">
                <h1>A/B Experiments</h1>
              </div>
              <div className="col text-end">
                <button
                  className="btn btn-primary"
                  onClick={this.handleNew}
                >
                  New Experiment
                </button>
              </div>
            </div>
            <br />
            <div className="btn-toolbar mb-3" role="toolbar">
              <div className="btn-group me-2" role="group">
                <button
                  type="button"
                  className={!statusFilter ? 'btn btn-secondary' : 'btn btn-outline-secondary'}
                  onClick={() => this.handleStatusFilter(null)}
                >
                  All
                </button>
                <button
                  type="button"
                  className={statusFilter === 'draft' ? 'btn btn-secondary' : 'btn btn-outline-secondary'}
                  onClick={() => this.handleStatusFilter('draft')}
                >
                  Draft
                </button>
                <button
                  type="button"
                  className={statusFilter === 'running' ? 'btn btn-secondary' : 'btn btn-outline-secondary'}
                  onClick={() => this.handleStatusFilter('running')}
                >
                  Running
                </button>
                <button
                  type="button"
                  className={statusFilter === 'paused' ? 'btn btn-secondary' : 'btn btn-outline-secondary'}
                  onClick={() => this.handleStatusFilter('paused')}
                >
                  Paused
                </button>
                <button
                  type="button"
                  className={statusFilter === 'ended' ? 'btn btn-secondary' : 'btn btn-outline-secondary'}
                  onClick={() => this.handleStatusFilter('ended')}
                >
                  Ended
                </button>
              </div>
            </div>
            {this.renderTable()}
            <br />
            <br />
          </div>
        </Route>
      </div>
    )
  }
}
